import { render, staticRenderFns } from "./InfoArmada.vue?vue&type=template&id=609f57f6&"
import script from "./InfoArmada.vue?vue&type=script&lang=js&"
export * from "./InfoArmada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports